import { DocumentLibraryOverlay } from '#app/routes/mocra+/_form+/components/document-libraries/overlay.tsx'
import { type DocumentLibraryDraft } from '#app/routes/mocra+/_form+/components/document-libraries/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: DocumentLibraryDraft) => void
	readonly initialValue: DocumentLibraryDraft
	readonly onClosed?: () => void
}

export function DocumentLibraryEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<DocumentLibraryOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
